var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    d: "M9.87863 9.28864L8.10478 7.51477C8.7678 6.71963 9.1673 5.69745 9.1673 4.58365C9.1673 2.05623 7.11108 0 4.58365 0C2.05623 0 0 2.0562 0 4.58365C0 7.1111 2.05623 9.1673 4.58365 9.1673C5.69781 9.1673 6.7203 8.76753 7.51555 8.10415L9.28937 9.87796C9.37073 9.95933 9.47738 10 9.584 10C9.69062 10 9.79729 9.95933 9.87863 9.87796C10.0414 9.7152 10.0414 9.45138 9.87863 9.28864ZM2.63907 6.52823C2.63907 5.45418 3.50972 4.58365 4.58365 4.58365C3.89327 4.58365 3.33354 4.02397 3.33354 3.33354C3.33354 2.6431 3.89327 2.08348 4.58365 2.08348C5.27403 2.08348 5.83374 2.64313 5.83374 3.33354C5.83374 4.02395 5.27403 4.58365 4.58365 4.58365C5.65756 4.58365 6.5282 5.45418 6.5282 6.52823H2.63907Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentIcon);
export default __webpack_public_path__ + "static/media/recruitmentIcon.800d7bcb4b279a9bcd357c7e608eb5e9.svg";
export { ForwardRef as ReactComponent };